<template>
	<van-row class="product">
		<van-row class="info">
			<van-col span="24" v-if="productInfo.name">
				<p class="title"><img src="../../assets/common/logo.png"/>销巴生活</p>
				<p class="name">{{productInfo.name}}</p>
				<p class="img"><img :src="productInfo.thumb" @error="defaultPro()" :style="imgSty"/></p>
				<p class="price" v-if="is_point_goods==-1">￥<span>{{price}}</span><del>￥{{productInfo.strikeout_price || productInfo.activity_max_price || productInfo.max_price}}</del></p>
				<p class="price" v-if="is_point_goods==1"><span>{{price}}积分</span></p>
				
			</van-col>
			<van-col span="24" class="btn">
				<div @click="open_mask()" v-if="isWeixin || isQQ">马上抢</div>
				<div @click="open_app()" v-else>马上抢</div>
			</van-col>
		</van-row>
		<div class="weixin-tip" v-if="maskShow">
			<p>
				<img  v-if="!isIOS" src="../../assets/common/live_weixin.png" alt="微信打开"/>
				<img  v-if="isIOS" src="../../assets/common/live_weixin_ios.png" alt="微信打开"/>
			</p>
		</div>
	</van-row>
</template>

<script>
import productDefault from '@/assets/common/preload.png';
export default {
	data() {
	    return {
	    	id: 0,
	      	productInfo: '',
	     	imgSty: {
	     		width: document.body.clientWidth * 0.64 + 'px',
	     		height: document.body.clientWidth * 0.64 + 'px'
	     	},
	     	price: '',
			is_point_goods: 0,
			isWeixin: false,
			isIOS: false,
			isQQ: false,
			maskShow: false,
			parmSrc: '',

	    };
	},
	created(){
//		this.$api.setToken(this.$route.query.token)
		this.getShopInfo();
		var u = navigator.userAgent;
		this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
		this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		// this.isQQ = ua.indexOf(' qq')>-1 && ua.indexOf('mqqbrowser') <0;
		if(u.toLowerCase().indexOf('qq')>-1 && u.toLowerCase().indexOf('mqqbrowser') <0 && this.isIOS){
            //qq内置浏览器
            this.isQQ = true;
		}
	},
	methods: {
	    getShopInfo() { 
	    	this.id = this.$route.query.id
	    	this.$api.get("/ongoods/index/goods/detail",{id:this.id}).then(res => {
		        if(res.goods) {
		        	this.productInfo = res.goods;
		        	this.is_point_goods = res.goods.is_point_goods;
		        	this.price = res.goods.activity_min_price || res.goods.min_price;
					if(this.is_point_goods == 1) {//积分商品
						this.parmSrc = 'home/goods_detail?goods_type=1&goods_id='+this.id;
					}else {//非积分商品
						this.parmSrc = 'home/goods_detail?goods_type=0&goods_id='+this.id;
					}
		        }
	        });
	  	},
	  	defaultPro() {
		  	var img = event.srcElement;
			img.src = productDefault;
			img.onerror = null; //防止闪图
		},
	    open_app() {
	    	let par = 'shareCode='+this.$route.query.shareCode+'&mobile='+this.$route.query.mobile;
	    	this.openApp('register', par, this.parmSrc);
		},
		open_mask() {
			this.maskShow = true;
		}
	}
};
</script>

<style lang="less">
.product {
	height: 100%;
	padding: 0 25px;
	background: -webkit-linear-gradient(#FF8583, #FF5D5B); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#FF8583, #FF5D5B); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#FF8583, #FF5D5B); /* Firefox 3.6 - 15 */
    background: linear-gradient(#FF8583, #FF5D5B); /* 标准的语法（必须放在最后） */
	.info {
		padding: 14px 0;
	    p {
	    	color: #fff;
	    	font-size: 18px;
	    }
	    .title {
		    font-size: 18px;
		    height: 40px;
		    line-height: 40px;
		    font-weight: bold;
		    img {
		    	width: 40px;
		    	height: 40px;    
		    	float: left;
    			margin-right: 15px;
		    }
		}
		.name{
			font-size: 24px;
			line-height: 42px;
			font-weight: bolder;
			padding: 0 4px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			white-space: normal;
			margin-top: 15px;
    		margin-bottom: 16px;
		}
		.img{
			text-align: center;
		}
		.price{
			text-align: center;
			font-size: 18px;
			font-weight: bold;
			margin-top: 15px;
			span {
				font-size: 40px;
			}
			del {
				font-size: 17px;
				font-weight: normal;
				margin-left: 10px;
			}
		}
		.btn{
			position: fixed;
			left: 0;
			bottom: 25px;
			padding: 0 25px;
			div {
				width: 100%;
				height: 49px;
				display: inline-block;
				background: url(../../assets/common/purchase.png) no-repeat;
				background-size: 100% 100%;
				text-align: center;
				line-height: 49px;
				color: #FF6461;
				font-size: 20px;
			}
		}
	}
	.weixin-tip {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 10;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .7);
		p {
			padding: 15px 25px;
			img {
				width: 100%;
				display: block;
			}
		}
	}
}
</style>
